import React from 'react';
import {ItemList} from './ItemList/ItemList';
import {ItemTable} from './ItemTable/ItemTable';
import {ItemGrid} from './ItemGrid/ItemGrid';
import {ItemProps} from './ItemProps';
import {LayoutViewType} from '../../models/LayoutViewType';

export interface ItemsViewProps extends ItemProps {
    readonly  itemLayout: string;
}

/**
 * @name ItemsView
 * @description
 * Composite component for presentation of Storage objects views
 */
export const ItemsView: React.VFC<ItemsViewProps> = (props) => {
    switch (props.itemLayout) {
        case LayoutViewType.LIST:
            return <ItemList {...props} />;
        case LayoutViewType.TABLE:
            return <ItemTable {...props} />;
        case LayoutViewType.GRID:
        default:
            return <ItemGrid {...props} />;
    }
};
